var React = require('react');

function Freshchat (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"Layer 1"},[React.createElement("path",{"fill":"#c0efe9","d":"M35 0h26.3a8.8 8.8 0 0 1 8.8 8.8V35a35 35 0 0 1-35 35A35 35 0 0 1 0 35 35 35 0 0 1 35 0Z","key":0}),React.createElement("path",{"fill":"#141618","d":"M45.8 22.2H28.3a8.8 8.8 0 0 0-8.8 8.8v14.9a2 2 0 0 0 2 2h24.3a8.8 8.8 0 0 0 8.7-8.8V31a8.8 8.8 0 0 0-8.7-8.8ZM39.5 41H26.8a1.7 1.7 0 1 1 0-3.4h12.7a1.7 1.7 0 0 1 0 3.4Zm7.7-8.3H26.8a1.7 1.7 0 1 1 0-3.4h20.4a1.7 1.7 0 0 1 0 3.4Z","key":1})])));
}

Freshchat.defaultProps = {"viewBox":"0 0 70.1 70.1"};

module.exports = Freshchat;

Freshchat.default = Freshchat;
